<template>
    <div>
        <div class="heading-travel-policy">
            <span :class="classOfServiceObj.isActive ? 'tag is-success' : 'tag'">Standard rule</span>

            <div class="right-content">
                <div class="lefttext">
                    <p class="paragrapgh">{{ title }}</p>
                    <p>Trigger for any flight where the class of service is:

                        <span class="rule-config-variable" @click="isEdit = !isEdit">
                            <span v-for="(res, i) in classOfServiceObj.value" :key="i">
                                {{ res.key ? res.value : $helpers.getAirClassLabel(res) + ',' }}
                            </span>
                            <b-icon icon="pencil" size="is-small"></b-icon>
                        </span>
                    </p>

                </div>
                <div class="allbtns">

                    <b-switch :rounded="true" :value="classOfServiceObj.isActive" v-model="classOfServiceObj.isActive"
                        @input="flightClassOfService" :left-label="true">{{ classOfServiceObj.isActive ? 'Active' :
                        'Inactive' }}
                    </b-switch>
                </div>
            </div>
        </div>
        <div v-if="isEdit" class="edittravelpolicy2">
            <AirClassOfService @classOfServices="getValue" :classOfSer="classOfServiceObj.value" />
            <p>Select class of service</p>
            <b-button @click="saveCall">SAVE</b-button>
        </div>
        <StandardRuleActions v-if="classOfServiceObj.isActive && !isEdit" :ruleObj="classOfServiceObj" :title="title"
            @save="updateActions" />
    </div>
</template>
<script>
import StandardRuleActions from "../StandardRuleActions.vue";
import AirClassOfService from '../CommonRules/AirClassOfService.vue';
export default {
    name: "ClassOfService",
    components: {
        AirClassOfService,
        StandardRuleActions
    },
    props: {
        value: {
            type: [Object],
        },
    },
    data() {
        return {
            classOfServiceObj: this.value ? this.value : {
                name: "flightClassOfService",
                isActive: false,
                value: ["Y"],
                type: "air",
                message: ''
            },
            isEdit: false,
            emitedValue: [],
            title: "Class of service"
        }
    },

    methods: {
        saveCall() {
            this.isEdit = false;
            if (this.emitedValue || this.emitedValue == '') {
                this.classOfServiceObj.value = this.emitedValue;
                this.buildMessage();
            }
        },
        getValue(val) {
            this.emitedValue = val;
        },
        flightClassOfService() {
            //this.classOfServiceObj.message = this.buildMessage;
            if (!this.classOfServiceObj.isActive) {
                // Clear the custom action parameters when deactivating
                this.clearActionParams();
            } else {
                // Rebuild message when activating
                this.buildMessage();
            }

            this.emitRuleObj();
        },
        clearActionParams() {
            // Reset to default actions when rule is not active ()
            this.classOfServiceObj.useCustomActions = false;
            delete this.classOfServiceObj.visibility;
            delete this.classOfServiceObj.approvalLevel;
            delete this.classOfServiceObj.notifications;
        },
        updateActions(updatedRule) {
            // Merge the updated properties into classOfServiceObj
            this.classOfServiceObj = { ...this.classOfServiceObj, ...updatedRule };

            // If useCustomActions is false, delete the associated properties
            if (!updatedRule.useCustomActions) {
                this.clearActionParams();
            }

            this.buildMessage();

            this.emitRuleObj();
        },
        buildMessage() {
            var string = 'Trigger for any flight where the class of service is ';
            this.classOfServiceObj.message = string + (this.classOfServiceObj.value ? this.classOfServiceObj.value.join(', '):'N/A');

        },
        emitRuleObj() {

            this.$emit('flightClassOfService', this.classOfServiceObj)
        }
    },
    mounted() {
        this.classOfServiceObj.type = 'air';
       
        this.emitRuleObj();
    },
    watch: {
        value: {
            handler(newVal, prevVal) {
                this.classOfServiceObj = this.value;
                this.classOfServiceObj.type = 'air';
                
                this.buildMessage();
                this.emitRuleObj();


            },
            deep: true,
        },
    },

}
</script>